/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDIgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjEyMDExNyAwLjVIMS44OTAxMlYyLjI3SDAuMTIwMTE3VjAuNVpNMC4xMjAxMTcgNS4xMkgxLjg5MDEyVjYuODlIMC4xMjAxMTdWNS4xMlpNMS44OTAxMiA5LjczSDAuMTIwMTE3VjExLjVIMS44OTAxMlY5LjczWiIgZmlsbD0iIzdGN0Y3RiIvPjwvc3ZnPg==";